import { ref, type Ref } from "vue"

export interface IDataAddress {
    address_1: string
    address_2: string | null | undefined
    address_id: number
    city: string
    city_id: number
    company: string | null | undefined
    country_id: number
    customer_id: number
    default: boolean | null
    postcode: string
    zone_id: number
    firstname?: string | undefined
    lastname?: string | undefined
    // refactored — adresin custom_field JSON'u (lat/lng/geo) sipariş'e
    // taşıyabilmek için adres seçim payload'unda da var olmalı.
    custom_field?: string | null
}

export interface IAddressSelectedOrderHappy {
    label: string
    value: string | number
    data: IDataAddress
    minimum_price: string
    price: string
    free_price: string
}

export const addressSelectedOrderHappyEmpty: IAddressSelectedOrderHappy = {
    label: '',
    value: '',
    data: {
        address_1: "",
        address_2: null,
        address_id: 0,
        city: "",
        city_id: 0,
        company: null,
        country_id: 0,
        customer_id: 0,
        default: false,
        postcode: "",
        zone_id: 0,
        firstname: undefined,
        lastname: undefined,
        custom_field: null,
    },
    minimum_price: '',
    price: '',
    free_price: ''
}
export const addressSelectedOrderHappy: Ref<IAddressSelectedOrderHappy> = ref(addressSelectedOrderHappyEmpty)